import { temporarilyNotSupport } from '../../utils'

// 支付
export const requestPayment = /* @__PURE__ */ temporarilyNotSupport('requestPayment')
export const requestPluginPayment = /* @__PURE__ */ temporarilyNotSupport('requestPluginPayment')
export const requestOrderPayment = /* @__PURE__ */ temporarilyNotSupport('requestOrderPayment')
